import { getItemCount, FAVORITE_NOT_LOADED, FETCH_FAVORITE_ITEMS, RECEIVE_FAVORITE_ITEMS } from '../actions/favorite'

const initialState = {
  itemCount: getItemCount(),
  itemLoadState: FAVORITE_NOT_LOADED,
  items: []
};

export function favorite(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAVORITE_ITEMS:
      return {
        ...state,
        itemLoadState: action.loadState
      };

    case RECEIVE_FAVORITE_ITEMS:
      return {
        ...state,
        itemLoadState: action.loadState,
        items: action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/favorite.js